import { render } from "./ForgotPassword.vue?vue&type=template&id=0e161052"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\doc\\MedRemind Project\\medremind-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__